module.exports = __webpack_public_path__ + "img/mastercard.eec03d5f.svg";